var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outer-container"},[_c('div',{ref:"container",staticClass:"inner-container",style:({ right: -_vm.scrollWidth + 'px', bottom: -_vm.scrollWidth + 'px' })},[_vm._t("default")],2),_vm._t("outer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }